import { combineReducers } from "redux";
import confirm from "./confirm";

export default combineReducers({
  confirm,
});
